import { useIntl } from 'react-intl';

import { ArticleCaption } from '@/core/components/ArticleCaption';
import { globalMessages } from '@/core/messages/global.messages';

import { getBackendImage } from '@/utils/helpers';

import {
  CardsGrid,
  FeaturedCard,
  Header,
  RowContainer,
  SubHeader,
} from './ArticlesGrid.styles';
import { FeaturedCardImage } from '../Articles.styles';
import { ArticleDataResponse } from '../Articles.types';

type ArticleDataProps = {
  ArticleData: ArticleDataResponse;
};

export const ArticlesGrid = ({ ArticleData }: ArticleDataProps) => {
  const { formatMessage } = useIntl();

  return (
    <CardsGrid>
      {ArticleData?.data?.map(article => {
        const imageAltText = article.attributes?.image?.data ?
          article.attributes?.image.data.attributes.alternativeText ||
          article.attributes?.title :
          formatMessage(globalMessages.patternImageAlt);

        return (
          <FeaturedCard
            href={String(article.attributes.slug)}
            key={article.id}
          >
            <FeaturedCardImage
              src={getBackendImage(
                article.attributes?.image?.data?.attributes?.url
              )}
              alt={imageAltText}
            />
            <Header>{article?.attributes?.title}</Header>
            <SubHeader>{article?.attributes?.subtitle}</SubHeader>
            <RowContainer>
              <ArticleCaption
                date={article?.attributes?.createdAt}
                topic={article?.attributes?.topics?.data[0]?.attributes?.name}
                readingTime={article?.attributes?.readingTime}
              />
            </RowContainer>
          </FeaturedCard>
        );
      })}
    </CardsGrid>
  );
};
